import { SolutionsMenuSizeType } from "@/types/all.types";
import { useMediaQuery } from "react-responsive";

export const useMenuSize = () => {
  const XL = useMediaQuery({ maxWidth: 1100 });
  const L = useMediaQuery({ maxWidth: 995 });
  const M = useMediaQuery({ maxWidth: 885 });
  const S = useMediaQuery({ maxWidth: 770 });

  const sizes = ["S", "M", "L", "XL"];
  const conditions = [S, M, L, XL];

  const trueIndex = conditions.findIndex((condition) => condition);
  return trueIndex !== -1 ? (sizes[trueIndex] as SolutionsMenuSizeType) : "default";
};
